import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WrongComponent } from './wrong.component';
import { MatIconModule } from '@angular/material/icon';
import { FlexLayoutModule } from '@angular/flex-layout';

@NgModule({
  declarations: [WrongComponent],
  imports: [CommonModule, MatIconModule, FlexLayoutModule],
  exports: [WrongComponent]
})
export class WrongModule {}
